import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SkillService {
  private baseUrl: string = `${environment.applicantApiEndpoint}/skill`;

  constructor(private httpClient: HttpClient) {}

  public create(name: string): Observable<string> {
    return this.httpClient.post<string>(this.baseUrl, { name });
  }
}
